import React, { useEffect, useState, useContext } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { DialogAction, useModal } from '../../../../function/useModal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import SelectSettings, { MenuContents } from '../../../organisms/SelectSettings';
// import SelectSettings, { MenuContents } from '../../../organisms/SelectSettings_copy';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import LayerShortSettingDialog, { LayerShortSettingDialogResponse } from './LayerShort/LayerShortSettingDialog';
import VibrationSettingDialog, { VibrationSettingDialogResponse } from './Vibration/VibrationSettingDialog';
import { DeviceRegistPageStyle } from './DeviceRegistStyle';
import DeviceRegistSettingDialogFooter from './DeviceRegistSettingDialogFooter';

export type DeviceRegistNewDialogProps = {
  dialog: DialogAction<DeviceRegistNewDialogResponse>;
  index: number;
};

export type DeviceRegistNewDialogResponse = {
};


const DeviceRegistSettingDialog: React.FC<DeviceRegistNewDialogProps> = (props: DeviceRegistNewDialogProps) => {
  const { t } = useTranslation();
  const tableBaseStyle = DeviceRegistPageStyle();
  const [isOpen, setOpen] = useState<boolean>(true);

  const [mode, setMode] = useState<boolean>(true);

  const [cancelflg, setCancelflg] = useState<boolean>(true);

  const menuList: MenuContents[] = [];

  const [flgVibrationSettingRowDlg, vibrationSettingRowDlg] = useModal<VibrationSettingDialogResponse>();


  useEffect(() => {
    /** 初期設定 */
    // setDevNo(1);
    // setItemName(1);
    //setCancelflg(false);
    console.debug(['DeviceRegistSettingDialog useEffect Check devIndex No', props.index])
  }, []);

  /**
   * キャンセル処理
   */
  const cancelAction = () => {
    console.debug('handleDialogConsole()');
    setOpen(false);
    setMode(false);
  };

  menuList.push({
    name: t('DeviceRegistSettingDialog.移動平均法設定', '移動平均法設定'),
    component: LayerShortSettingDialog,
    tag: 'LayerShortSetting',
  });
  menuList.push({
    name: t('DeviceRegistSettingDialog.周波数範囲設定', '周波数範囲設定'),
    component: VibrationSettingDialog,
    tag: 'VibrationSetting',
  });

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        PaperProps={
          {
            style: {
              width: '80%',  // ダイアログの幅を設定
              maxWidth: '700px',  // 最大幅を設定
              //height: '60%',
            },
          }
        }
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {t('DeviceRegistSettingDialog.設定画面', '設定画面')}
        </DialogTitle> */}
        <DialogActions>
          {/** メニュータブの表示 */}
          <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginRight: 0 }}>
            <SelectSettings menuList={menuList} dialogColoseAction={cancelAction} selectIndexNo={props.index}
              isSelectMenu={0} />
          </Grid>
        </DialogActions>

      </Dialog>
    </>


  );

}



export default DeviceRegistSettingDialog;